// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WarningOutlinedSvg from "@fishx/icons-svg/es/asn/WarningOutlined";
import FishxIcon from '../components/FishxIcon';

var WarningOutlined = function WarningOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WarningOutlinedSvg
  }));
};

WarningOutlined.displayName = 'WarningOutlined';
export default React.forwardRef(WarningOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WarningOutlined.js
// module id = 4390
// module chunks = 0